import React, { useState } from 'react';
import { siteConfig } from '../data';
import { Send } from 'lucide-react';

export default function Contact() {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="pt-8 md:pt-12 pb-24 animate-in fade-in duration-1000">
      <div className="max-w-5xl mx-auto px-6">
        <header className="mb-24">
          <h1 className="text-3xl md:text-4xl font-serif text-slate-900 mb-6">Kontakt</h1>
          <p className="text-lg text-slate-500 font-light max-w-2xl">
            Kontaktoplysninger og adresse for Sandberg Rådgivende Ingeniører ApS.
          </p>
        </header>

        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div className="space-y-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Honeypot */}
              <div className="sr-only absolute -z-10">
                <label htmlFor="website_url">Website URL</label>
                <input type="text" id="website_url" name="website_url" tabIndex="-1" autoComplete="off" />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label htmlFor="name" className="text-[10px] uppercase tracking-widest text-slate-400 font-medium">Navn</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-300 focus:outline-none focus:border-slate-900 transition-colors rounded-none"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className="text-[10px] uppercase tracking-widest text-slate-400 font-medium">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-300 focus:outline-none focus:border-slate-900 transition-colors rounded-none"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label htmlFor="subject" className="text-[10px] uppercase tracking-widest text-slate-400 font-medium">Emne</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-300 focus:outline-none focus:border-slate-900 transition-colors rounded-none"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="message" className="text-[10px] uppercase tracking-widest text-slate-400 font-medium">Besked</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="5"
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-300 focus:outline-none focus:border-slate-900 transition-colors resize-none rounded-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="bg-slate-900 text-white px-8 py-4 rounded-none font-medium hover:bg-slate-800 transition-colors inline-flex items-center gap-2"
              >
                Send besked
                <Send className="w-4 h-4" />
              </button>

              {status === 'success' && (
                <p className="text-green-600 text-sm">Tak for din besked. Vi vender tilbage hurtigst muligt.</p>
              )}
              {status === 'error' && (
                <p className="text-red-600 text-sm">Der skete en fejl. Prøv venligst igen senere.</p>
              )}
            </form>

            <div className="grid grid-cols-2 gap-8 pt-8 border-t border-slate-100">
              <div>
                <h2 className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-medium mb-4">Adresse</h2>
                <p className="text-slate-900 text-sm leading-relaxed">
                  {siteConfig.contact.address}
                </p>
              </div>
              <div>
                <h2 className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-medium mb-4">Kontakt</h2>
                <p className="text-slate-900 text-sm leading-relaxed">
                  {siteConfig.contact.phone}<br />
                  {siteConfig.contact.email}
                </p>
              </div>
            </div>
          </div>

          <div className="aspect-[3/4] bg-slate-100 overflow-hidden">
            <img 
              src="https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/fb1983cb-7993-4d15-983e-75ae915ddfae.jpg" 
              alt="Kamstrup bygning" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
